export default {
    methods: {
        finishTryout() {
            const history_hash = this.$store.get('tryout/history_hash')
            this.$tracking.event.tryout.finish(
                `${this.$store.get('tryout/title')} ${this.$store.get('enrollment/selected@title')}`
            )

            this.$api.put(`work/${this.$store.get('tryout/history_hash')}/finish`, {}, { loader: 'finishing' })
                .then(() => [
                    this.$router.replace({ name: 'grade.detail', params: { history_hash } })
                ])
        }
    }
}
